module.exports = __webpack_public_path__ + "static/media/NebaneAbienwi.49cf9940.png";